import { render, staticRenderFns } from "./BudgetsListItem.vue?vue&type=template&id=2c49b782&"
import script from "./BudgetsListItem.vue?vue&type=script&lang=js&"
export * from "./BudgetsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports